import * as React from 'react';
import Utils from '../../common/utils';

interface Props {
	className?: string;
	payment: PaymentHistory;
}
const FailedPaymentDetails: React.StatelessComponent<Props> = props => {
	return (
		<div className={props.className}>
			<h2 className="form-fieldset-title">Payment Details</h2>
			<div className="form-fieldset">
				<ul className="list-unstyled mb-0">
					<li><strong>Date:</strong> {Utils.formatDate(props.payment.date)}</li>
					<li><strong>Invoice #:</strong> {props.payment.stripeInvoiceNumber}</li>
					<li><strong>Amount:</strong> {Utils.formatCurrency(props.payment.amount)}</li>
					<li><strong>Status:</strong> {Utils.getPickListItemDescription(props.payment.statusId)}</li>
				</ul>
			</div>
		</div>
	);
};
export default FailedPaymentDetails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/FailedPaymentDetails.tsx